module.exports = __webpack_public_path__ + "img/image12.d0abc692.png";